const ListItem = [
  {
    id: 0,
    src: 'https://food-cms.grab.com/compressed_webp/merchants/5-C3UFEKCGCTWJN6/hero/40e1d2113ee84198954b2b2de56986b0_1698747624261130157.webp',
    title: 'Bánh Mì Tuhu Bread - Trần Nhân Tông',
    moreInfo: 'Bánh Mì - Xôi, Cơm Chay - Salad Healthy - Đồ Chay, Ăn Vặt',
    rating: 4.5,
    time: ' 30 phút ',
    distance: ' 2.2km ',
    special: ' Ưu đãi đến 45K ',
    warn: '',
    href: '#',
  },
  {
    id: 1,
    src: 'https://food-cms.grab.com/compressed_webp/merchants/5-C32YGCBGV3UCE2/hero/5d590dcf-4f10-41e6-a1e8-1919ac8e55e6__store_cover__2023__12__01__18__27__19.webp',
    title: 'Bánh Mì Sài Gòn - 204d Đội Cấn',
    moreInfo: 'Bánh Mì - Xôi, Gà Rán - Burger, Cà Phê - Trà - Sinh Tố - Nước Ép',
    rating: 4.8,
    time: ' 30 phút ',
    distance: ' 2.5km ',
    special: ' Ưu đãi đến 40K ',
    warn: '',
    href: '#',
  },
  {
    id: 2,
    src: 'https://food-cms.grab.com/compressed_webp/merchants/5-C3CEAELZREMUGT/hero/09562ad8727447a78f8f65d5ae28d7a5_1687430615308541764.webp',
    title: 'Burger Factory - Base 2',
    moreInfo: 'Gà Rán - Burger',
    rating: 4.5,
    time: ' 35 phút ',
    distance: ' 2.9km ',
    special: ' 🔥Grab Ngon Rẻ🔥 Bao Giá & Bao Ship',
    // warn: 'Sắp đóng cửa - Đặt món trước 5 AM',
    warn: '',
    href: '#',
  },
  {
    id: 3,
    src: 'https://food-cms.grab.com/compressed_webp/merchants/5-C32DT6NCDCBBFA/hero/cc56c86a71594d56b1e613bdd3f068d6_1670410743363665847.webp',
    title: 'Ngọc Lan - Bún Phở Miến - Tôn Đức Thắng',
    moreInfo: 'Bún - Phở - Cháo',
    rating: 3.2,
    time: ' 30 phút ',
    distance: ' 0.7km ',
    special: ' Ưu đãi lên đến 40K ',
    warn: '',
    href: '#',
  },
];
export default ListItem;
